import { render, staticRenderFns } from "./UserChangePermissionsModal.vue?vue&type=template&id=55aa9165&"
import script from "./UserChangePermissionsModal.vue?vue&type=script&lang=js&"
export * from "./UserChangePermissionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports